import {$controller} from "rapid/index";
import {forEach} from "lodash";

const dependencies = ["$Configuration", "$companies"];

class ScenesController extends $controller {

    constructor($injector, $scope, $photoTransform, $ToViewValue) {
        "ngInject";
        super($injector, dependencies);
        this.$scope = $scope;
        this.Math = Math;
        this.photoTransform = $photoTransform;
        this.toViewValue = $ToViewValue;
    }

    $onInit() {
        this.$scope.$watch(() => this.model.photos[0].width, () => {
            this.setEachScene();
        });
        this.$scope.$watch(() => this.model.photos[0].height, () => {
            this.setEachScene();
        });
        this.$scope.$watch(() => this.model.photos[0].x, () => {
            this.setEachScene();
        });
        this.$scope.$watch(() => this.model.photos[0].y, () => {
            this.setEachScene();
        });
        this.$scope.$watch(() => this.model.photos[0].angle, () => {
            this.setEachScene();
        });
        this.$scope.$watch(() => this.liveView, () => {
            this.setEachScene();
        });
        this.$scope.$watch(() => this.model, () => {
            if (!this.model.hasOwnProperty("scenesNamesShow")) {
                Object.assign(this.model, {scenesNamesShow: false});
            }
        });
        this.$scope.$watch(() => {
            if (!this.model.opacity) {
                this.model.opacity = 50;
            }
        });
    }

    $onChanges(changes) {
        if (changes.previousValue !== changes.currentValue) this.setEachScene();
    }

    onLayoutDialogOpen(oldValue) {
        if (oldValue) {
            let confirm = this.$mdDialog.confirm()
                .title("Change aspect ratio & crop scenes?")
                .textContent("Your already created scenes will be cropped to fit the new scene aspect ratio.")
                .ariaLabel("Scene delete")
                .ok("CONTINUE")
                .cancel("CANCEL");
            this.$mdDialog.show(confirm).then(() => {
                this.setLayout();
            }).catch(() => {
                this.model.sceneLayoutAspectRatio = oldValue;
                this.setLayout();
            });
        } else {
            this.setLayout();
        }
    }

    setLayout() {
        let round2 = (x) => {
            return Math.ceil(x/2)*2;
        };
        let widthIndex, heightIndex;
        this.model.layoutHeight = 500;
        this.model.layoutWidth = 500;
        this.model.photos[0].changed = Math.random();
        switch (this.model.sceneLayoutAspectRatio) {
            case "square":
                this.model.customLayoutWidth = null;
                this.model.customLayoutHeight = null;
                break;
            case "landscape":
                this.model.layoutHeight = 334;
                this.model.layoutWidth = 500;
                this.model.customLayoutWidth = null;
                this.model.customLayoutHeight = null;
                break;
            case "portrait":
                this.model.layoutHeight = 500;
                this.model.layoutWidth = 334;
                this.model.customLayoutWidth = null;
                this.model.customLayoutHeight = null;
                break;
            case "custom":
                if (!this.model.customLayoutHeight || !this.model.customLayoutWidth || this.model.customLayoutWidth < 0 || this.model.customLayoutHeight < 0) {
                    this.model.customLayoutWidth = 1;
                    this.model.customLayoutHeight = 1;
                }
                if (this.model.customLayoutHeight/this.model.customLayoutWidth >= 0.1 && this.model.customLayoutHeight/this.model.customLayoutWidth <= 10) {
                    widthIndex = this.model.customLayoutWidth;
                    heightIndex = this.model.customLayoutHeight;
                }
        }

        if (widthIndex && heightIndex) {
            if (widthIndex > heightIndex) {
                this.model.layoutHeight = round2((heightIndex * this.model.layoutWidth) / widthIndex);
            } else {
                this.model.layoutWidth = round2((widthIndex * this.model.layoutHeight) / heightIndex);
            }
        }
        this.setEachScene();
    }

    changeSharingLayoutSize(setting, value) {
        let widthIndex, heightIndex;
        let round2 = (num) => this.Math.ceil(num/2) * 2;

        widthIndex = 1;
        heightIndex = 1;
        switch (this.model.sceneLayoutAspectRatio) {
            case "square":
                break;
            case "landscape":
                widthIndex = 3;
                heightIndex = 2;
                break;
            case "portrait":
                widthIndex = 2;
                heightIndex = 3;
                break;
            case "custom":
                if (widthIndex && heightIndex) {
                    widthIndex = this.model.customLayoutWidth;
                    heightIndex = this.model.customLayoutHeight;
                }
                break;
        }
        if (value === "height") {
            this.model.layoutWidth = Math.round((this.model.layoutHeight * widthIndex) / heightIndex);
            this.model.layoutWidth = round2(this.model.layoutWidth);
        } else {
            this.model.layoutHeight = Math.round((this.model.layoutWidth * heightIndex) / widthIndex);
            this.model.layoutHeight = round2(this.model.layoutHeight);
        }
        this.setEachScene();
    }

    changePhotosAspectRatio() {
        let widthIndex, heightIndex;
        forEach(this.model.photos, (ph) => {
            ph.storedWidth = ph.width;
            ph.storedHeight = ph.height;
            ph.width = getSquare(ph.width, ph.height);
            ph.height = getSquare(ph.width, ph.height);
        });

        switch (this.model.photoAspectRatio) {
            case "square":
                widthIndex = 1;
                heightIndex = 1;
                this.model.customPhotoHeight = null;
                this.model.customPhotoWidth = null;
                break;
            case "landscape":
                widthIndex = 3;
                heightIndex = 2;
                this.model.customPhotoHeight = null;
                this.model.customPhotoWidth = null;
                break;
            case "portrait":
                widthIndex = 2;
                heightIndex = 3;
                this.model.customPhotoHeight = null;
                this.model.customPhotoWidth = null;
                break;
            case "custom":
                if (!this.model.customPhotoHeight || !this.model.customPhotoWidth || this.model.customPhotoWidth < 0 || this.model.customPhotoHeight < 0) {
                    this.model.customPhotoWidth = 1;
                    this.model.customPhotoHeight = 1;
                }
                if (this.model.customPhotoHeight/this.model.customPhotoWidth >= 0.1 && this.model.customPhotoHeight/this.model.customPhotoWidth <= 10) {
                    widthIndex = this.model.customPhotoWidth;
                    heightIndex = this.model.customPhotoHeight;
                }
                break;
        }

        if (widthIndex && heightIndex) {
            if (widthIndex >= heightIndex) {
                forEach(this.model.photos, (ph) => {
                    ph.height = Math.round((heightIndex * ph.width) / widthIndex);
                    this.photoTransform.centrePhoto(ph);
                });
            } else {
                forEach(this.model.photos, (ph) => {
                    ph.width = Math.round((widthIndex * ph.height) / heightIndex);
                    this.photoTransform.centrePhoto(ph);
                });
            }
        }

        this.setEachScene();

        function getSquare(a,b) {
            return Math.max(a,b);
        }

    }

    getLayoutMinSize(config) {
        const getValidSize = (ratio) => {
            const graterSide = this.model.customLayoutWidth > this.model.customLayoutHeight ?
                this.model.customLayoutWidth : this.model.customLayoutHeight;
            const smallerSide = this.model.customLayoutWidth < this.model.customLayoutHeight ?
                this.model.customLayoutWidth : this.model.customLayoutHeight;
            switch (ratio) {
                case "square":
                    return 500;
                case "portrait":
                    return 334;
                case "landscape":
                    return 334;
                case "custom":
                    return Math.ceil(smallerSide * 500 / graterSide / 2) * 2;
                default:
                    return 500;
            }
        };

        if (this.model.sceneLayoutAspectRatio === "square" || this.model.sceneLayoutAspectRatio === "portrait" ||
            (this.model.sceneLayoutAspectRatio === "custom" && this.model.customLayoutWidth < this.model.customLayoutHeight )) {
            if (config === "height") {
                return 500;
            } else {
                return getValidSize(this.model.sceneLayoutAspectRatio);
            }
        } else {
            if (config === "height") {
                return getValidSize(this.model.sceneLayoutAspectRatio);
            } else {
                return 500;
            }
        }
    }

    getFiles(arr) {
        if (!arr || !arr.length) return [];
        let newArr = [];
        forEach(arr, (file) => {
            if (file.attachment_file_alpha) {
                newArr.push(file.attachment_file_alpha);
            }else {
                newArr.push(file.attachment_file);
            }
        });
        return newArr;
    }

    getCanvasTitle() {
        // The preview is the screen size here: its own ratio, e.g. 9:16 for 1080×1920
        if (this.liveView && this.liveView.liveViewMode === "fullscreen") {
            const ratio = this.toViewValue.detectAspectRatioObject(Number(this.general.width), Number(this.general.height));
            return `${ratio.w}:${ratio.h}`;
        }

        switch (this.model.sceneLayoutAspectRatio) {
            case "landscape":
                return "3:2";
            case "portrait":
                return "2:3";
            case "square":
                return "1:1";
            case "custom":
                return `${this.model.customLayoutWidth}:${this.model.customLayoutHeight}`;
        }
    }

    setEachScene() {
       this.model.photos[0].image = true;
        this.model.photos[0].gif = false;
        this.model.photos[0].video = false;
        forEach(this.model.scenesList, (s) => {
            s.sceneLayoutAspectRatio = this.model.sceneLayoutAspectRatio;
            s.customLayoutHeight = this.model.customLayoutHeight;
            s.customLayoutWidth = this.model.customLayoutWidth;
            s.layoutHeight = this.model.layoutHeight;
            s.layoutWidth = this.model.layoutWidth;
            s.photoAspectRatio = this.model.photoAspectRatio;
            s.customPhotoHeight = this.model.customPhotoHeight;
            s.customPhotoWidth = this.model.customPhotoWidth;
            s.photos = this.model.photos;
            s.scenesList = {
                photo: true,
                gif: true,
                boomerang: true,
                video: true
            };
            if (!s.captureModes){
                s.captureModes = [
                    {
                        mode: "photo",
                        enabled: true
                    },
                    {
                        mode: "gif",
                        enabled: true
                    },
                    {
                        mode: "boomerang",
                        enabled: true
                    },
                    {
                        mode: "video",
                        enabled: true
                    },
                ];
            }
        });
    }

    onSceneToggleChange() {
        this.callback();
    }

    changeSceneBtnTitle(){
        console.log(this.model.scenesBtnTitleShow, "|| =>",this.model.sceneBtnTitle);
    }
}

export default ScenesController;



// WEBPACK FOOTER //
// ./sources/components/configurations/scenes/scenes.controller.js